/*
 * One-Minute Maths
 * Copyright © 2021 White Rose Maths
 * Square.js - A square for the ten frame.
*/

import React from 'react';
import {
  Dimensions
} from 'react-native';
import PropTypes from 'prop-types';
import './SubitisingScreen.web.css';

// eslint-disable-next-line no-unused-vars
const { width, height } = Dimensions.get('window');

export default class SubitiseElement extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    // If the object image is defined use that
    if (this.props.object != null || this.props.object != undefined) {
      return (
        <div id="square">
          <img className="subitising_object" src={this.props.object} />
        </div>
      );
    }

    if (this.props.colour != 'clear') {
      return (
        <div id="square">
          <div id="circle" style={{ backgroundColor: this.props.colour }} />
        </div>
      );
    }

    return (
      <div id="square">
        <div id="empty" />
      </div>
    );

  }
}

SubitiseElement.propTypes = {
  props: PropTypes.object,
  colour: PropTypes.string,
  object: PropTypes.number,
};
